import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGamejoltComponent } from './simple-icons-gamejolt.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGamejoltComponent ],
    exports:      [ SimpleIconsGamejoltComponent ],
    bootstrap:    []
})
export class SimpleIconsGamejoltModule {}
